export default __webpack_public_path__ + "assets/upload-image.65b9df83.png";